import { render, staticRenderFns } from "./DettagliContatto.vue?vue&type=template&id=400033eb"
import script from "./DettagliContatto.vue?vue&type=script&lang=js"
export * from "./DettagliContatto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports